import { BaseModal } from "./BaseModal";
import Button, { ButtonVariants } from "./Button";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function SwitchNetworkModal(_ref) {
  let {
    networkName,
    onSwitchNetwork,
    action,
    isOpen,
    setIsOpen
  } = _ref;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _jsx(BaseModal, {
      isOpen: isOpen,
      onClose: () => {},
      hideCloseButton: true,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          "data-testid": "switch-networks-modal",
          className: "flex",
          children: /*#__PURE__*/_jsx("div", {
            className: "text-center",
            children: /*#__PURE__*/_jsxs("div", {
              "data-testid": "switch-networks-modal-title",
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-primary-text text-[18px] flex justify-center p-2",
                children: "Switch Networks to Continue"
              }), /*#__PURE__*/_jsxs("p", {
                className: "text-gitcoin-grey-400 text-[16px] flex justify-center p-2",
                children: ["To ", action || "donate", ", you need to switch the network on your wallet to ", networkName, "."]
              })]
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          "data-testid": "switch-networks-modal-button",
          className: "w-full justify-center text-center grid grid-cols-2 gap-3",
          children: [/*#__PURE__*/_jsx(Button, {
            variant: ButtonVariants.outline,
            onClick: () => setIsOpen(false),
            styles: ["cancel-button"],
            children: /*#__PURE__*/_jsx("span", {
              className: "inline-flex flex-1 justify-center items-center",
              children: "Cancel"
            })
          }), /*#__PURE__*/_jsx(Button, {
            styles: ["p-3", "justify-center"],
            onClick: onSwitchNetwork,
            variant: ButtonVariants.outline,
            children: "Switch Network"
          })]
        })]
      })
    })
  );
}
export default SwitchNetworkModal;